import { OfflineDirectSigner, DirectSignResponse } from '@cosmjs/proto-signing';
import { SignDoc } from 'cosmjs-types/cosmos/tx/v1beta1/tx';
import { AccountData } from '@cosmjs/amino';
import { OfflineSigner as DefiConnectOfflineSigner } from '@deficonnect/cosmos-signer';
import Long from 'long';

export class DefiConnectOfflineSignerWrapper implements OfflineDirectSigner {
  private readonly defiConnectOfflineSigner: DefiConnectOfflineSigner;

  constructor(defiConnectOfflineSigner: DefiConnectOfflineSigner) {
    this.defiConnectOfflineSigner = defiConnectOfflineSigner;
  }

  public async getAccounts(): Promise<readonly AccountData[]> {
    return this.defiConnectOfflineSigner.getAccounts();
  }

  public async signDirect(
    signerAddress: string,
    signDoc: SignDoc
  ): Promise<DirectSignResponse> {
    const transformedSignDoc = {
      accountNumber: Long.fromString(signDoc.accountNumber.toString()),
      bodyBytes: signDoc.bodyBytes,
      authInfoBytes: signDoc.authInfoBytes,
      chainId: signDoc.chainId,
    };
    return this.defiConnectOfflineSigner.signDirect(
      signerAddress,
      transformedSignDoc
    );
  }
}
